import { textStyles as o } from "../../textStyles.es.js";
import { a as u } from "../../../chunk-OA3DH5LS-40f95340.js";
import { Input as r } from "./Input.es.js";
const g = u("MultiEmailMessage").parts(
  "control",
  "error",
  "group",
  "input",
  "root",
  "textarea"
);
var e, a, t, i, n, s, p, d, l;
const m = {
  parts: g.keys,
  baseStyle: {
    control: {
      lineHeight: 1
    },
    error: {
      color: "error.500",
      ...o.md
    },
    group: {
      flexDirection: "column",
      ...(e = r.baseStyle) == null ? void 0 : e.group,
      ...(a = r.variants) == null ? void 0 : a.primary.group,
      borderRadius: "radius-100",
      textarea: {
        borderTopWidth: "1px",
        borderTopColor: "primary.100",
        borderTopStyle: "solid"
      },
      _hover: {
        ...(t = r.variants) == null ? void 0 : t.primary.group._groupHover
      },
      _focusVisible: {
        ...(i = r.variants) == null ? void 0 : i.primary.group._groupFocusWithin
      },
      _focusWithin: {
        ...(n = r.variants) == null ? void 0 : n.primary.group._groupFocusWithin,
        textarea: {
          borderTopColor: "secondary.500"
        }
      },
      _invalid: {
        ...(s = r.variants) == null ? void 0 : s.error.group,
        textarea: {
          borderTopColor: "error.300"
        },
        _focusWithin: {
          ...(p = r.variants) == null ? void 0 : p.error.group._groupFocusWithin,
          textarea: {
            borderTopColor: "error.500"
          }
        },
        _hover: {
          ...(d = r.variants) == null ? void 0 : d.error.group._groupHover
        }
      }
    },
    input: {
      width: "full",
      boxShadow: "none",
      borderColor: "transparent",
      borderRadius: "radius-100",
      _hover: {
        boxShadow: "none",
        borderColor: "transparent"
      },
      _focus: {
        boxShadow: "none",
        borderColor: "transparent"
      },
      _focusVisible: {
        boxShadow: "none",
        borderColor: "transparent"
      },
      _groupFocusWithin: {
        boxShadow: "none",
        borderColor: "transparent"
      }
    },
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "spacing-100"
    },
    textarea: {
      width: "full",
      ...o.lg,
      ...(l = r.baseStyle) == null ? void 0 : l.field,
      resize: "none",
      minHeight: "100px",
      height: "100px",
      boxShadow: "none",
      outline: "none",
      borderColor: "transparent",
      borderRadius: "none",
      borderBottomRightRadius: "radius-100",
      borderBottomLeftRadius: "radius-100",
      paddingY: "spacing-100",
      paddingX: "spacing-200",
      lineHeight: "1.2",
      _placeholder: {
        ...o.lg
      }
    }
  }
};
export {
  m as MultiEmailMessage,
  g as MultiEmailMessageAnatomy
};
//# sourceMappingURL=MultiEmailMessage.es.js.map
